import moment from "moment";
import React, { useEffect, useState } from "react";
import {
	Button,
	FormText,
	Modal,
	OverlayTrigger,
	Tooltip
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiCheck, BiChevronDown, BiX } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FormService from "../../../../core/service/FormService";
import { update_dce } from "../CreateDataCollectionEvent/CreateDataCollectionEvent";
import { FormType } from "../../../../core/constants/common";
import MatAssessmentService from "../../../../core/service/MatAssessmentService";

function AssessmentReshareModal({ t, assessment, onHide, onSuccess, selfAssessment, formType = FormType.GENERAL }) {
	const navigate = useNavigate();
	const location = useLocation();

	const [branches, setBranches] = useState([]);
	const [selectedBranches, setSelectedBranches] = useState([]);
	const [sharedEmailsDisplay, setSharedEmailsDisplay] = useState({});
	const [expandedBranches, setExpandedBranches] = useState({});

	useEffect(() => {
		if (!assessment?.id) return;

		if (formType === FormType.SURVEY) {
			getSharedGroups();
		} else {
			getSharedBranches();
		}
	}, [assessment]);

	const getSharedBranches = () => {
		FormService.getSharedBranchesForAssessment(assessment?.id).then(res => {
			if (res.status !== 200) return;

			getSharedCount(res.data);
			setBranches(res.data);
		}).catch(err => { });
	};

	// Permissions are edited on the update page; coming back reopens this dialog for the same assessment
	const goToPermissions = (e) => {
		e.preventDefault();
		navigate(update_dce.replace("<id>", assessment.id), {
			state: {
				selfAssessment: selfAssessment,
				openPermissions: true,
				returnTo: `${location.pathname}${location.search}`,
				returnState: { ...(location.state ?? {}), reshareAssessment: assessment }
			}
		});
	};

	const onSave = () => {
		let req;
		if (formType === FormType.SURVEY) {
			const payload =[];
			selectedBranches?.forEach(group => {
				group.sharedEmails?.forEach(s => payload.push({ id: s.id}));
			});
			req = MatAssessmentService.reshareAssessment(assessment.id, payload);
		} else {
			req = FormService.reshareAssessment(assessment.id, selectedBranches);
		}
		req.then(res => {
			if (res.status !== 200) return;

			toast.success(t("MatAssessmentShareSuccessMessage.label"), {
				position: toast.POSITION.TOP_RIGHT,
			});
			onSuccess();
		}).catch((error) => { });
	};

	const isBranchSelected = (branch) => {
		return branch.sharedEmails?.every(email => isEmailSelected(email.email, branch));
	};

	const onBranchCheck = (branch) => {
		const s = JSON.parse(JSON.stringify(selectedBranches));
		const branchesToSelect = [];
		branchesToSelect.push(branch);
		iterateAndSelectBranches(branch.children, branchesToSelect);
		for (let index = 0; index < branchesToSelect.length; index++) {
			const bToselect = branchesToSelect[index];
			const sIndex = s?.findIndex(b => b.id === bToselect.id);
			if (sIndex >= 0) {
				s.splice(sIndex, 1);
			} else {
				s.push(bToselect);
			}
		}
		setSelectedBranches(s);
	};

	const iterateAndSelectBranches = (branchList, branchesToSelect) => {
		branchList?.forEach(branch => {
			branchesToSelect.push(branch);
			iterateAndSelectBranches(branch.children, branchesToSelect);
		});
	};

	const isEmailSelected = (email, branch) => {
		const index = selectedBranches?.findIndex(b => b.id === branch.id);
		if (index < 0) return false;

		return selectedBranches[index].sharedEmails?.findIndex(e => e.email === email) >= 0;
	};

	const onEmailCheck = (email, branch) => {
		const s = JSON.parse(JSON.stringify(selectedBranches));
		const sIndex = selectedBranches?.findIndex(b => b.id === branch.id);
		if (sIndex >= 0) {
			const eIndex = s[sIndex].sharedEmails?.findIndex(e => e.email === email);
			if (eIndex >= 0) {
				s[sIndex].sharedEmails?.splice(eIndex, 1);
			} else {
				s[sIndex].sharedEmails.push({ email: email, shared: true });
			}
		} else {
			const sharedEmails = branch.sharedEmails;
			let newBranch = JSON.parse(JSON.stringify(branch));
			newBranch.sharedEmails = sharedEmails?.filter(e => e.email === email);
			s.push(newBranch);
		}
		setSelectedBranches(s);
	};

	const onSelectAllCheck = (event) => {
		if (event.target.checked) {
			const branchesToSelect = [];
			iterateAndSelectBranches(branches, branchesToSelect);
			setSelectedBranches(branchesToSelect);
		} else {
			setSelectedBranches([]);
		}
	};

	const isAllSelected = () => {
		const branchesToSelect = [];
		iterateAndSelectBranches(branches, branchesToSelect);
		return branchesToSelect.length === selectedBranches.length;
	};

	const getSharedCount = (branch) => {
		if (formType === FormType.SURVEY)  {
			branch.map(g=> {
				let shared = (g.sharedEmails.filter(x => x.shared)).length;
				g['sharedInfo'] = shared;
			});
		} else {
			branch.map(data=> {
				if(data?.businessUnitType=='Branch' || data?.businessUnitType=='Department') {
					let shared = (data.sharedEmails.filter(x=>x.shared)).length;
					data['sharedInfo'] = shared;
					if(data.children.length>0) {
						getSharedCount(data.children);
					} else {
						return;
					}
				}
			});
		}		
	}

	const renderSharedLabel = (branch)  => {
		if (formType === FormType.SURVEY ||branch.businessUnitType === 'Branch' || branch.businessUnitType === 'Department') {
			return (
				<span className="Share_statusbox">
					<span className="text-muted"><b>{branch.sharedInfo + '/' + branch.sharedEmails.length + ' Shared'}</b></span>
				</span>
			);
		} else {
			return (
				<span className="Share_statusbox">
					<BiX className="text-danger" style={{ fontSize: '20px', marginTop: '-2px' }} />{' '}
					<span className="text-muted">{t('NotShared.label')}</span>
				</span>
			);
		}
	};

	const renderEmailIds = (branch, branchIndex, bodyPaddingLeft) => {
		return (
			branch.sharedEmails?.map((email, emailIndex) => {
				return (
					<div className="card-0100_body">		
						<div className="card-0100_body_01" 
							key={`branchRow-${branchIndex}-emailRow-${emailIndex}`}
							style={{paddingLeft: bodyPaddingLeft}}>
							<div className="form-check" style={{ minHeight: "auto" }}>
								<input
									className="form-check-input"
									type="checkbox"
									id={`email-input-${branch.id}-${email.email}`}
									checked={formType === FormType.SURVEY ? isStakeGroupEmailSelected(email, branch) : isEmailSelected(email.email, branch)}
									onChange={() => formType === FormType.SURVEY ? onStakeGroupEmailCheck(email, branch) : onEmailCheck(email.email, branch)}
								/>
								<label
									className="form-check-label"
									htmlFor={`email-input-${branch.id}-${email.email}`}>
									{email.email}
								</label>
							</div>
							{
								email.shared
									?
									<span>
										<BiCheck
											className="text-Medium"
											style={{ fontSize: '20px', marginTop: '-2px' }}
										/>{' '}
										<span className="text-muted">{t('Shared.label')}</span>
									</span>
									:
									<span>
										<BiX
											className="text-danger"
											style={{ fontSize: '20px', marginTop: '-2px' }}
										/>{' '}
										<span className="text-muted">{t('NotShared.label')}</span>
									</span>
							}
						</div>
					</div>
				);
			})
		);			
	};

	const renderTree = (branchList, depth = 0, parentId = 0) => {
		const headerMarginLeft = depth === 0 ? '0px' : `${30 + (depth * 10)}px`;
		const bodyPaddingLeft = depth === 0 ? '50px' : `${50 + (depth * 50)}px`;
		return (
			<>
			{
				branchList?.map((branch, branchIndex) => {
					return (
						<div className={`card Card_0100 ${depth > 0 ? 'no-border' : ''}`} key={`branchRow-${depth}-${branchIndex}`}>
							<div className="card-0100_header" style={{marginLeft: headerMarginLeft}}>
								<span
									className="Enterprise_Groups_AccoBox"
									onClick={() => {
										const exp = JSON.parse(JSON.stringify(expandedBranches));
										exp[branch.id] = exp[branch.id] === true ? false : true;											
										setExpandedBranches(exp);
									}}>
									<BiChevronDown />
								</span>
								<div className="form-check">
									<input
										className="form-check-input"
										type="checkbox"
										id={`branch-input-${branch.id}`}
										checked={isBranchSelected(branch)}
										onChange={() => onBranchCheck(branch)}/>
									<label className="form-check-label" htmlFor={`branch-input-${branch.id}`}>
										{branch.name}
									</label>
								</div>
								{renderSharedLabel(branch)}
							</div>								
							{expandedBranches[branch.id] === true && renderEmailIds(branch, branchIndex, bodyPaddingLeft)}
							{expandedBranches[branch.id] === true && branch.children?.length > 0 && renderTree(branch.children, depth + 1, branch.id)}
						</div>
					);
				})
			}
			</>
		);
	};

	// Note -  This is the old implementation. We might need this alter.
	const renderBranches = () => {
		branches?.map((branch, branchIndex) => {
			return (
				<>
					<div className="card Card_0100">
						<div className="card-0100_header">
							<span
								className="Enterprise_Groups_AccoBox"
								onClick={() => {
									setSharedEmailsDisplay(prevState => ({
										...prevState,
										[branch.id]: !prevState[branch.id]
									}));
								}}>
								<BiChevronDown />
							</span>
							<div className="form-check">
								<input
									className="form-check-input"
									type="checkbox"
									id={`branch-input-${branch.id}`}
									checked={isBranchSelected(branch)}
									onChange={() => onBranchCheck(branch)}
								/>
								<label className="form-check-label" htmlFor={`branch-input-${branch.id}`}>
									{branch.name}
								</label>
							</div>
							{
								branch.assessmentShared
									?
									<span className="Share_statusbox">
										<BiCheck className="text-Medium" style={{ fontSize: '20px', marginTop: '-2px' }} />{' '}
										<span className="text-muted">{t('Shared.label')}</span>
									</span>
									:
									<span className="Share_statusbox">
										<BiX className="text-danger" style={{ fontSize: '20px', marginTop: '-2px' }} />{' '}
										<span className="text-muted">{t('NotShared.label')}</span>
									</span>
							}
						</div>
						{sharedEmailsDisplay[branch.id] &&
							branch.sharedEmails?.map((email, emailIndex) => {
								return (
									<div className="card-0100_body">

										<div className="card-0100_body_01" key={`branchRow-${branchIndex}-emailRow-${emailIndex}`}>
											<div className="form-check" style={{ minHeight: "auto" }}>
												<input
													className="form-check-input"
													type="checkbox"
													id={`email-input-${branch.id}-${email.email}`}
													checked={isEmailSelected(email.email, branch)}
													onChange={() => onEmailCheck(email.email, branch)}
												/>
												<label
													className="form-check-label"
													htmlFor={`email-input-${branch.id}-${email.email}`}
												>
													{email.email}
												</label>
											</div>
											{
												email.shared
													?
													<span>
														<BiCheck
															className="text-Medium"
															style={{ fontSize: '20px', marginTop: '-2px' }}
														/>{' '}
														<span className="text-muted">{t('Shared.label')}</span>
													</span>
													:
													<span>
														<BiX
															className="text-danger"
															style={{ fontSize: '20px', marginTop: '-2px' }}
														/>{' '}
														<span className="text-muted">{t('NotShared.label')}</span>
													</span>
											}
										</div>
									</div>
								);
							})}
					</div>
				</>
			);
		})
	};

	const renderExpiryLabel = () => {
		const lastSubmissionDate = new Date(assessment?.lastSubmissionDate);
		const isExpired = lastSubmissionDate < new Date();
		return (
			<div>
				{
					isExpired
					?
					<span className="text-danger">{t('Expired.label')}</span>
					:
					<span className="text-muted">
						{t('Expiry.label')} : {assessment?.lastSubmissionDate ? moment(assessment?.lastSubmissionDate).format("MMM DD, YYYY") : ''}
					</span>
				}				
			</div>
		)
	};

	const getSharedGroups = () => {
		MatAssessmentService.getSharedGroupsForAssessment(assessment.id).then(res => {
			if (res.status !== 200) return;

			getSharedCount(res.data);
			setBranches(res.data);
		}).catch(err => { });
	};


	const renderGroups = (groups) => {
		return (
			<>
			{
				groups?.map((group, groupIndex) => {
					return (
						<div className={`card Card_0100`} key={`branchRow-${groupIndex}`}>
							<div className="card-0100_header">
								<span
									className="Enterprise_Groups_AccoBox"
									onClick={() => {
										const exp = JSON.parse(JSON.stringify(expandedBranches));
										exp[group.id] = exp[group.id] === true ? false : true;											
										setExpandedBranches(exp);
									}}>
									<BiChevronDown />
								</span>
								<div className="form-check">
									<input
										className="form-check-input"
										type="checkbox"
										id={`branch-input-${group.id}`}
										checked={isGroupSelected(group)}
										onChange={() => onBranchCheck(group)}/>
									<label className="form-check-label" htmlFor={`branch-input-${group.id}`}>
										{group.name}
									</label>
								</div>
								{renderSharedLabel(group)}
							</div>								
							{expandedBranches[group.id] === true && renderEmailIds(group, groupIndex, '50px')}
						</div>
					);
				})
			}
			</>
		);
	};

	const isGroupSelected = (group) => {
		return group.sharedEmails?.every(stakeholder => isStakeGroupEmailSelected(stakeholder, group));
	};

	const isStakeGroupEmailSelected = (stakeholder, group) => {
		const index = selectedBranches?.findIndex(b => b.id === group.id);
		if (index < 0) return false;

		return selectedBranches[index].sharedEmails?.findIndex(e => e.id === stakeholder.id) >= 0;
	};


	const onStakeGroupEmailCheck = (stakeholder, group) => {
		const s = JSON.parse(JSON.stringify(selectedBranches));
		const sIndex = selectedBranches?.findIndex(b => b.id === group.id);
		if (sIndex >= 0) {
			const eIndex = s[sIndex].sharedEmails?.findIndex(e => e.id === stakeholder.id);
			if (eIndex >= 0) {
				s[sIndex].sharedEmails?.splice(eIndex, 1);
			} else {
				s[sIndex].sharedEmails.push({ id: stakeholder.id, email: stakeholder.email, shared: true });
			}
		} else {
			const sharedEmails = group.sharedEmails;
			let newBranch = JSON.parse(JSON.stringify(group));
			newBranch.sharedEmails = sharedEmails?.filter(e => e.id === stakeholder.id);
			s.push(newBranch);
		}
		setSelectedBranches(s);
	};

	return (
		<>
			<Modal show={true} onHide={() => onHide()}
				aria-labelledby="contained-modal-title-vcenter"
				size="xl"
				className="Reshare_modal-box"
				centered>
				<Modal.Header closeButton className="border-0 pb-2">
					<div>
						<div className="modal-title h4" >
							{t('Share.label')} "{assessment.assessmentForm?.name} - {moment(assessment?.period).format("MMMM, YYYY")}"
						</div>
						{renderExpiryLabel()}
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="001 pb-2">
						<h6 className="m-0 fw-600">{t('ChooseEntitiesToShare.label')}</h6>
						<div className="Card_0100_01">

							<div className="form-check">
								<OverlayTrigger
									placement="top"
									overlay={<Tooltip id="tooltip-select-all">{t('SelectAllTooltip.label')}</Tooltip>}
								>
									<input
										className="form-check-input"
										type="checkbox"
										id="select-all-branches"
										checked={isAllSelected()}
										onChange={onSelectAllCheck}
									/></OverlayTrigger>
								<span>{t('AllEntitiesGroupWithAssignedPermission.label')}</span>
							</div>
							<span onClick={goToPermissions}><a href="#">{t('GoToPermission.label')}</a></span>
						</div>
						<div className="ChooseEntitiesShare_List">
						{formType === FormType.GENERAL && renderTree(branches, 0)}
						{formType === FormType.SURVEY && renderGroups(branches)}
						</div>
					</div>
					<div className="text-center p-2">
						<Button variant="secondary" className="mx-2" onClick={() => onHide()}>{t('Cancel.label')}</Button>
						<Button variant="primary" onClick={() => onSave()} disabled={selectedBranches.length === 0}>{t('Share.label')}</Button>
					</div>
				</Modal.Body>

			</Modal>
		</>
	);
}

export default withTranslation()(AssessmentReshareModal);

